<template>
  <div class="overlay" v-if="show">
    <div class="overlay_inner channel_list">
      <p class="note" v-translate>Výběr profilového obrázku</p>
      <div class="scrollable_popup">
        <div class="profile_images">
          <div v-for="image in images" @click="onClick(image.name, image.path)" class="profile_image_item" :class="{'selected' : image.name === selected}" >
            <img :src="image.path" alt="profile_image" />
          </div>

        </div>
      </div>
      <a @click="setShow(false)" class="btn btn_action btn_close" title="Zavřít" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectImagePopup',
  props: {
    nameSelected: String,
  },
  data(){
    return {
      images: [],
      show: false,
      selected: null,
    }
  },
  created(SubscriberProfileService){
    this.subscriberProfileService = SubscriberProfileService;
  },
  methods:{
    setShow(state){
      this.show = state;
      this.selected = this.nameSelected;
      if(this.show && !this.images.length){
        this.subscriberProfileService.getImageList()
            .then(data => {
              this.images = data['list'];
            })
      }
    },
    onClick(name, path){
      this.selected = name;
      this.$emit('input', name, path);
      this.setShow(false);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/subscriberProfile/SelectImagePopup.vue